import actions from './actions';

// Superintresse purchases. The sheet itself is the 'SuperInterestPurchase'
// global modal (ui/showGlobalModal) and the balance lives in menu/
// superLikesRemaining. This module owns opening a purchase (web sheet, or
// the app's panel inside the app's web view), the balance refresh on a
// booked superlikes payment, and the payment-redirect reopen.
export default {
  namespaced: true,
  actions
};
